import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-folder-upload",
  "use": "icon-folder-upload-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-folder-upload\"><path d=\"M13 4H8.5L7 2H3a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h3v-1H3a1 1 0 0 1-1-1V5h11a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-3v1h3c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2M2 4a1 1 0 0 1 1-1h3.5l.75 1z\" /><path d=\"m8 6.309-2.6 2.6.7.7 1.4-1.4v6.8h1v-6.8l1.4 1.4.7-.7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol